import React from 'react';
import '../../css/auth.css';

export const authFieldSx = {
  mb: 2.5,
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    minHeight: 56,
    overflow: 'visible',
    backgroundColor: '#f4f4f5',
    color: '#1a1a1a',
    fontSize: '16px',
    fontWeight: 400,
    '& fieldset': {
      borderColor: '#d4d4d8',
    },
    '&:hover fieldset': {
      borderColor: '#a1a1aa',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--auth-accent)',
      borderWidth: '1px',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#6b7280',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.4,
    '&.Mui-focused': {
      color: 'var(--auth-accent)',
    },
  },
  '& .MuiInputAdornment-root, & .MuiIconButton-root': {
    color: '#6b7280',
  },
  '& input': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
    padding: '16px 14px',
    color: '#1a1a1a',
    height: '1.5em',
    boxSizing: 'content-box',
  },
};

const AuthLayout = ({ logo, logoAlt = 'FireCore', title, subtitle, children, footer }) => (
  <div className="authenticate-back">
    <div className="authenticate-center">
      <div className="authenticate-logo">
        <img className="authenticate-logo-image" src={logo} alt={logoAlt} />
      </div>
      <div className="authenticate-window">
        {title && <h1 className="authenticate-title">{title}</h1>}
        {subtitle && <p className="authenticate-subtitle">{subtitle}</p>}
        {children}
        {footer}
      </div>
    </div>
  </div>
);

export default AuthLayout;
